import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { CheckButton } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

export const TextMessageConsentField: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const canSendTextMessages = useBrokerDetailsStore((s) => s.canSendTextMessages);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);

    return (
        <CheckButton
            id='canSendTextMessages'
            selected={canSendTextMessages}
            onToggle={() => updateFields({ canSendTextMessages: !canSendTextMessages })}
            label='I consent to receive text messages'
            width={mobileScreen ? '100%' : '400px'}
        />
    );
};
